<template>
  <q-layout view="hhh Lpr fff">
    <WebHeader
      v-if="showLayout"
      redirect-after-logout="index"
      :burger-menu="headerBurgerMenu"
    />
    <AeroflotBanner v-if="domain.is.aeroflot" />
    <q-page-container>
      <router-view />
    </q-page-container>
    <template v-if="showLayout">
      <WebFooter>
        <template
          v-if="!domain.hideTrademark"
          #mobile
        >
          <div class="column text-center text-grey text-caption q-py-8 bg-white">
            <span>©KG GLOBAL LIMITED. GetTransfer® is trademark of KG GLOBAL LIMITED.</span>
            <span class="q-mb-16 ios-bottom-padding">All rights reserved.</span>
          </div>
        </template>
      </WebFooter>
    </template>
  </q-layout>
</template>

<script setup>
import { useQuasar } from 'quasar';
import { inject, useSSRContext } from 'vue';

import AeroflotBanner from '~components/AeroflotBanner';
import WebFooter from '~components/WebFooter';
import WebHeader from '~components/WebHeader';

defineProps({
  showLayout: {
    type: Boolean,
    required: true,
  },
});

const $q = useQuasar();
const ssrContext = process.env.SERVER ? useSSRContext() : null;

const domain = inject('domain');

const headerBurgerMenu = ssrContext?.req.headerBurgerMenu || $q.cookies.has('headerBurgerMenu');
</script>

<style lang="scss" scoped>
.q-footer {
  padding-bottom: 0 !important;
}

.text-caption {
  font-size: .65rem;
}
</style>
